import React, { useEffect, useRef, useState } from "react";
import Header from "../../Home/Header";
import Navbar from "../../commons/Navbar";
import "../../Home/style.css";
import HeaderBox from "../../Home/HeaderBox";
import styles from "../ProductStyle.module.css";
import Arr from "../../assets/product.json";

const ReductionSleeves = ({ navigationId, setNavigationId }) => {
  const windowSizeResolution = useRef(null, "windowSizeResolution");
  useEffect(() => {
    window.innerWidth === 1536
      ? (windowSizeResolution.current.id = "rest-banner")
      : (windowSizeResolution.current.id = "rest-banner");
  }, []);
  const alphabetArray = "abcdefghijklmnopqrstuvwxyz".split("");
  // const [navId, setNavId] = useState(1);
  // const handleCallback = (childdata) => {
  //   setNavigationId(childdata);
  // };
  // console.log(Arr[0].megaMenu[0].subMenu);
  return (
    <>
      <div className="rest-banner" ref={windowSizeResolution}>
        <HeaderBox id={navigationId} />
        <Header />
        <Navbar setNavigationId={setNavigationId} />
        <div className="container-fluid">
          <div className={`row min_height ${styles.ContentContainer}`}>
            <div>
              <h2>Reduction Sleeves</h2>
              <h5>
                At Sphoorti India, we manufacture high-quality Reduction Sleeves
                in different variants called Type1,2 and 3 per DIN 6335 for
                various boring tool holders of slotted tool discs; they can hold
                multiple shank diameters.The reduction sleeves are manufactured
                to fit with ETP tool Holders and are especially suited for high
                precision clamping of cylindrical tool shanks.
              </h5>
            </div>
            <div className={styles.DictionaryContainer}>
              {alphabetArray.map((alpha, i) => {
                return (
                  <>
                    {Arr[2].megaMenu.some((element) =>
                      element.title.startsWith(alpha.toUpperCase())
                    ) && (
                      <div className={styles.AlphaContainer} key={i}>
                        <b>{alpha.toUpperCase()}</b>
                        <ul>
                          {Arr[2].megaMenu.map((element, index) => {
                            return (
                              element.title.startsWith(alpha.toUpperCase()) && (
                                <li key={index}>
                                  {
                                    <a
                                      // onClick={() => handleSelectManu(element)}
                                      href={`https://www.sphoorti.com${element.link}`}
                                    >
                                      {element.title}
                                    </a>
                                  }
                                </li>
                              )
                            );
                          })}
                        </ul>
                      </div>
                    )}
                  </>
                );
              })}
            </div>
          </div>
        </div>
        {/* <SideBanner />
        <About /> */}
        {/* <div className="container border-1">
          <div className="row ">
            <div className="col-md-3 border-1 d-flex align-items-end ">
              <SideBanner parentCallback={handleCallback} />
            </div>
            <div className="col-md-8 " style={{ marginTop: "2%" }}>
              {navId === 0 && <Banner />}
              {navId === 1 && <About />}
              {navId === 2 && <Products />}
              {navId === 3 && <Infrastructure />}
              {navId === 4 && <NewsAndEvents />}
              {navId === 5 && <Catalogue />}
            </div>
          </div>
        </div> */}
        {/* <div className="container ">
          <div className="row">
            <div className="col-md-10 " style={{ marginTop: "2%" }}>
              {navId === 0 && <Banner />}
              {navId === 1 && <About />}
              {navId === 2 && <Products />}
              {navId === 3 && <Infrastructure />}
              {navId === 4 && <NewsAndEvents />}
              {navId === 5 && <Catalogue />}
            </div>
          </div>
          <div className="row">
            <div className="col-10">
              <SideBanner parentCallback={handleCallback} />
            </div>
          </div>
        </div> */}
      </div>

      {/* <br /> */}
    </>
  );
};

export default ReductionSleeves;
